import * as React from 'react';
import * as autoBind from 'react-autobind';
import Strings from '../../globals/Strings';
import Constants, {SortMetric, ButtonActivationKeys} from '../../globals/Constants';
import {Glyphs} from '@techsmith/tsc-cloud-style-guide';
import GoogleAnalyticsService from '../../services/GoogleAnalyticsService/GoogleAnalyticsService';
import Config from '../../globals/Config';

export default class SortingsMenu extends React.Component<SortingsMenuProps, {}> {
   constructor(props: SortingsMenuProps) {
      super(props);
      autoBind(this);
   }

   onSortingSelectClick(sortMetric: SortMetric) {
      this.props.setSortMetric(sortMetric);

      switch (sortMetric) {
         case SortMetric.createdDateAscending: {
            return GoogleAnalyticsService.trackReviewSortingMetricSwitch(Config.user.techSmithId, Constants.googleAnalytics.sortReviews.action.dateAsc);
         }
         case SortMetric.createdDateDescending: {
            return GoogleAnalyticsService.trackReviewSortingMetricSwitch(Config.user.techSmithId, Constants.googleAnalytics.sortReviews.action.dateDesc);
         }
         case SortMetric.titleAscending: {
            return GoogleAnalyticsService.trackReviewSortingMetricSwitch(Config.user.techSmithId, Constants.googleAnalytics.sortReviews.action.titleAsc);
         }
         case SortMetric.titleDescending: {
            return GoogleAnalyticsService.trackReviewSortingMetricSwitch(Config.user.techSmithId, Constants.googleAnalytics.sortReviews.action.titleDesc);
         }
         default: {
            return;
         }
      }
   }

   onKeyDown(e: any, sortMetric: SortMetric): void {
      if (e.keyCode in ButtonActivationKeys && !e.shiftKey) {
         this.props.setSortMetric(sortMetric);
      }
   }

   getButton(title: string, label: string, testId: string, sortMetric: SortMetric) {
      return (
         <div className="setting" role="button" onClick={() => this.onSortingSelectClick(sortMetric)} onKeyDown={e => this.onKeyDown(e, sortMetric)} title={title} data-test-id={testId} tabIndex={0}>
            <div className="setting setting-button">
               {label}
            </div>
            {this.props.sortMetric === sortMetric && <Glyphs.Checkmark16x16/>}
         </div>
      );
   }

   render() {
      const sortStrings = Strings.labels.sortDirectionButton;
      return (
         <div className="options-menu sortings-menu">
            {this.getButton(sortStrings.date.descending.title, sortStrings.date.descending.label, 'sort-menu-date-descending', SortMetric.createdDateDescending)}
            {this.getButton(sortStrings.date.ascending.title, sortStrings.date.ascending.label, 'sort-menu-date-ascending', SortMetric.createdDateAscending)}
            {this.getButton(sortStrings.title.ascending.title, sortStrings.title.ascending.label, 'sort-menu-title-ascending', SortMetric.titleAscending)}
            {this.getButton(sortStrings.title.descending.title, sortStrings.title.descending.label, 'sort-menu-title-descending', SortMetric.titleDescending)}
         </div>
      );
   }
}

export interface SortingsMenuProps {
   sortMetric: SortMetric;
   setSortMetric(sortMetric: SortMetric): void;
}
